export default __webpack_public_path__ + "static/media/photo4.edb8e3ee.jpg";